import { Card, CardBody, Row, TabContent, TabPane, Spinner } from 'reactstrap';
import CommonProjectList from '../Common/CommonGroupList';
import { Group, useFetchGroups } from '../../../../hooks/useFetchGroups';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

interface GroupListTabContentProps {
  activeTab: number;
  userId: string;
  role: string;
}

export default function GroupListTabContent({ activeTab, userId, role }: GroupListTabContentProps) {
  const { loading, error, refetch,userSpecificGroups,fetchUserSpecificGroups } = useFetchGroups(userId, role); // Add refetch function

  const groups=userSpecificGroups; // Access allGroups from Redux store

  useEffect(()=>{
    fetchUserSpecificGroups(true);
  },[activeTab])

  const refetchGroups = () => {
    fetchUserSpecificGroups(true); // Trigger refetch to get the latest data
  };

  if (loading) {
    return (
      <Card>
        <CardBody className="text-center">
          <Spinner color="primary" />
        </CardBody>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <CardBody className="text-center text-danger">
          {error}
        </CardBody>
      </Card>
    );
  }

  const activeGroups = groups.filter((group:Group) => !group?.isArchived);
  const archivedGroups = groups.filter((group:Group) => group?.isArchived);

  return (
    <Card>
      <CardBody>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1}>
            <Row>
              {activeGroups?.map((group: Group, index:number) => (
                <CommonProjectList item={group} key={index} refetchGroups={refetchGroups} />
              ))}
            </Row>
          </TabPane>
          <TabPane tabId={2}>
            <Row>
              {archivedGroups?.map((group: Group, index: number) => (
                <CommonProjectList item={group} key={index} refetchGroups={refetchGroups} />
              ))}
            </Row>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );
}